<template>
  <div v-if="$Can('view_user_report')">
    <b-card>

      
      <b-card-header>
        <b-card-title class="d-flex justify-content-between align-items-center w-100">
          <div class="d-flex align-items-center">      {{ selectedReport == 'Time Report' ? 'User Time Report' : 'User Clinic Report' }}
        <b-dropdown id="dropdown-time-clinic-report" text="Time Report" variant="link" class="ml-2">
          <template #button-content>
            <span>{{ selectedReport }}</span>
            <i class="fa fa-chevron-down ml-2"></i>
          </template>
          <b-dropdown-item @click="selectReport('Time Report')">Time Report</b-dropdown-item>
          <b-dropdown-item @click="selectReport('Clinic Report')">Clinic Report</b-dropdown-item>
        </b-dropdown>
        </div>
        <div>
          <b-button class="ml-5" variant="success" @click="downloadPDF"
              >Download PDF</b-button
            >
        </div>
      </b-card-title>
    </b-card-header>


      <div
        class="mb-2 text-center d-flex justify-content-center align-items-center"
      >
        <b-row class="">
          <b-col cols="12" lg="2">
            <treeselect
              v-model="selectedDepartments"
              @input="selectedFilters"
              value-consists-of="LEAF_PRIORITY"
              :limit="3"
              :multiple="true"
              :options="departmentOptions"
            />
          </b-col>

          <b-col cols="12" lg="3">
            <treeselect
              v-model="selectedTasks"
              @input="selectedFilters"
              value-consists-of="LEAF_PRIORITY"
              :limit="3"
              :multiple="true"
              :options="taskOptions"
            />
          </b-col>

          <b-col cols="12" lg="3">
            <treeselect
              class="mr-25"
              v-model="selectedUser"
              value-consists-of="LEAF_PRIORITY"
              :multiple="true"
              :options="allUsers"
              @input="selectedFilters"
              :limit="3"
              :clearable="false"
            >
            </treeselect>
          </b-col>
          <b-col cols="12" lg="2">
            <treeselect
              class="mr-25"
              v-model="selectedRoles"
              value-consists-of="LEAF_PRIORITY"
              :multiple="true"
              :options="allRoles"
              @input="selectedFilters"
              :limit="3"
              :clearable="false"
            >
            </treeselect>
          </b-col>


          <b-col cols="12" lg="2">
            <flat-pickr
              v-model="selectedDates"
              class="form-control bg-white w-100"
              :config="datePickerConfig"
            />
          </b-col>

          <b-col cols="12" lg="12" class="mt-50">
            <b-button class="mr-1" variant="info" @click="selectThisWeek"
              >This Week</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectThisMonth"
              >This Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectLastMonth"
              >Last Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectNextMonth"
              >Next Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectThisYear"
              >This Year</b-button
            >
     
          </b-col>
        </b-row>
      </div>

      <b-row class="text-center">
        <b-col md="12" class="text-center">
          <b-card style="text-align: center;">
            <canvas
              id="userWeeklyTasksBarChart"
              width="400"
              height="200"
            ></canvas>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="d-flex justify-content-end mb-2">
            <b-button variant="success" @click="userDataExport"
              >Export .xlsx</b-button
            >
          </div>
        </b-col>
      </b-row>
      <b-row>
        <UserTable :userTable="userTable" />
      </b-row>

    </b-card>
  </div>

  <div v-else class="text-center mt-5 text-danger">
    No Permission
  </div>
</template>

<script>
import reportStoreModule from "./reportStoreModule";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import Chart from "chart.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import UserTable from "./UserTable.vue";


export default {
  setup() {
    const USER_REPORT_APP_STORE_MODULE_NAME = "user-report";
    if (!store.hasModule(USER_REPORT_APP_STORE_MODULE_NAME))
      store.registerModule(
        USER_REPORT_APP_STORE_MODULE_NAME,
        reportStoreModule
      );
    onUnmounted(() => {
      if (store.hasModule(USER_REPORT_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_REPORT_APP_STORE_MODULE_NAME);
    });
  },

  components: {
    flatPickr,
    Treeselect,
    UserTable
  },

  data() {
    return {
      selectedReport : 'Time Report',
      selectedDates: [],
      departmentOptions: [],
      taskOptions: [],
      selectedDepartments: [],
      selectedTasks: [],
      selectedRoles: [],
      allUsers: [],
      allRoles: [],
      userTasks: [],
      selectedUser: [],
      chartInstance: null,
      datePickerConfig: {
        dateFormat: "d/m/Y",
        mode: "range",
        locale: {
          firstDayOfWeek: 1, // Monday
        },
        onChange: this.onDateChange,
      },
      userTable:[],
    };
  },

  created() {
    if (this.$Can("view_user_report")) this.setDefaultDates();
  },

  methods: {
    selectReport(report){
      this.selectedReport = report;
      this.renderCharts();
    },
    selectedFilters() {
      if (!this.selectedDates || this.selectedDates.length === 0) {
        return;
      }

      let dates = [];

      if (
        typeof this.selectedDates === "string" &&
        this.selectedDates.includes(" to ")
      ) {
        const [startDateStr, endDateStr] = this.selectedDates.split(" to ");

        const startDate = this.parseDate(startDateStr);
        const endDate = this.parseDate(endDateStr);

        dates = [startDate, endDate];
      } else if (Array.isArray(this.selectedDates)) {
        dates = this.selectedDates.map((date) => new Date(date));
      }

      // Tarihleri ISO formatına çevir
      const formattedDates = dates.map(
        (date) => date.toISOString().split("T")[0]
      );

      this.fetchUserReport(formattedDates);
    },

    parseDate(dateStr) {
      const [day, month, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    },

    setDefaultDates() {
      const now = new Date();
      const firstDayOfWeek = now.getDate() - now.getDay() + 1; // Monday
      const lastDayOfWeek = firstDayOfWeek + 6; // Sunday
      const firstDay = new Date(now.setDate(firstDayOfWeek));
      const lastDay = new Date(now.setDate(lastDayOfWeek));
      this.selectedDates = [firstDay, lastDay];

      this.fetchUserReport(this.selectedDates);
    },

    onDateChange(selectedDates) {
      if (
        JSON.stringify(this.selectedDates) !== JSON.stringify(selectedDates)
      ) {
        this.selectedDates = selectedDates;
        this.fetchUserReport(this.selectedDates);
      }
    },

    fetchUserReport(selectedDates) {
      if (selectedDates.length !== 2) return;

      let [startDate, endDate] = selectedDates;
      startDate = new Date(startDate).toISOString().split("T")[0];
      endDate = new Date(endDate).toISOString().split("T")[0];

      store
        .dispatch("user-report/userReport", {
          startDate,
          endDate,
          userIds: this.selectedUser,
          selectedDepartments: this.selectedDepartments,
          selectedTasks: this.selectedTasks,
          selectedRoles : this.selectedRoles
        })
        .then((res) => {
          this.userTasks = res.data.data;
          this.allUsers = res.data.users;
          this.allRoles = res.data.roles;
          this.userTable = res.data.userTable;
          this.taskDistributionByPriority = res.data.taskDistributionByPriority;
          this.departmentOptions = res.data.departments;
          this.taskOptions = res.data.tasks;
          this.renderCharts();
        })
        .catch((error) => {
          console.error("Error fetching user report:", error);
        });
    },

    userDataExport() {
      store
        .dispatch("user-report/userDataExport", { datas: this.userTable })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/octet-stream",
          });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "user_report.xlsx");
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((error) => {
          this.$swal({
            title: "Error!",
            text: "Report could not be loaded!" + error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
    },

    renderCharts() {
      this.renderUserWeeklyTasksBarChart();
    },

    renderUserWeeklyTasksBarChart() {
  if (this.chartInstance) {
    this.chartInstance.destroy();
  }

  const ctx = document
    .getElementById("userWeeklyTasksBarChart")
    .getContext("2d");
  const labels = this.userTasks.map((user) => user.user_name);
  const datasets = [];

  // Initialize and fill datasets with actual values based on selected report
  this.userTasks.forEach((user) => {
    user.tasks.forEach((task) => {
      let dataset = datasets.find((d) => d.label === task.task_title);
      if (!dataset) {
        dataset = {
          label: task.task_title,
          data: Array(this.userTasks.length).fill(0),
          backgroundColor: task.color,
        };
        datasets.push(dataset);
      }
      dataset.data[
        this.userTasks.findIndex((u) => u.user_id === user.user_id)
      ] = this.selectedReport === 'Time Report' ? task.total_minutes : task.count;
    });
  });

  this.chartInstance = new Chart(ctx, {
    type: "bar",
    data: {
      labels,
      datasets,
    },
    options: {
      responsive: true,
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                if (this.selectedReport === 'Time Report') {
                  const hours = Math.floor(value / 60);
                  const minutes = (value % 60).toString().padStart(2, "0");
                  return `${hours}:${minutes}`;
                } else {
                  return value;
                }
              }.bind(this),
            },
          },
        ],
      },
      hover: {
        animationDuration: 0,
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const value = dataset.data[tooltipItem.index];
            if (value !== 0) {
              if (this.selectedReport === 'Time Report') {
                const hours = Math.floor(value / 60);
                const minutes = (value % 60).toString().padStart(2, "0");
                return `${dataset.label}: ${hours}:${minutes}`;
              } else {
                return `${dataset.label}: ${value}`;
              }
            }
            return "";
          }.bind(this),
        },
      },
      legend: {
        display: true,
      },
    },
  });
},

    selectThisWeek() {
      const now = new Date();
      const firstDayOfWeek = now.getDate() - now.getDay() + 1; // Monday
      const lastDayOfWeek = firstDayOfWeek + 6; // Sunday
      const dates = [
        new Date(now.setDate(firstDayOfWeek)),
        new Date(now.setDate(lastDayOfWeek)),
      ];
      this.selectedDates = dates;
      this.fetchUserReport(dates);
    },

    selectThisMonth() {
      const now = new Date();
      const dates = [
        new Date(now.getFullYear(), now.getMonth(), 1),
        new Date(now.getFullYear(), now.getMonth() + 1, 0),
      ];
      this.selectedDates = dates;
      this.fetchUserReport(dates);
    },

    selectLastMonth() {
      const now = new Date();
      const dates = [
        new Date(now.getFullYear(), now.getMonth() - 1, 1),
        new Date(now.getFullYear(), now.getMonth(), 0),
      ];
      this.selectedDates = dates;
      this.fetchUserReport(dates);
    },

    selectNextMonth() {
      const now = new Date();
      const dates = [
        new Date(now.getFullYear(), now.getMonth() + 1, 1),
        new Date(now.getFullYear(), now.getMonth() + 2, 0),
      ];
      this.selectedDates = dates;
      this.fetchUserReport(dates);
    },

    selectThisYear() {
      const now = new Date();
      const dates = [
        new Date(now.getFullYear(), 0, 1),
        new Date(now.getFullYear(), 11, 31),
      ];
      this.selectedDates = dates;
      this.fetchUserReport(dates);
    },

    convertMinutesToHoursMinutes(minutes) {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return `${hours}:${remainingMinutes.toString().padStart(2, "0")}`;
    },

    downloadPDF() {
      let dates = null;
      if (
        typeof this.selectedDates === "string" &&
        this.selectedDates.includes(" to ")
      ) {
        const [startDateStr, endDateStr] = this.selectedDates.split(" to ");

        const startDate = this.parseDate(startDateStr);
        const endDate = this.parseDate(endDateStr);

        dates = [startDate, endDate];
      } else {
        dates = this.selectedDates;
      }
      const userAnalysisTable = this.userTasks
  .map((user) => {
    return user.tasks.map((task) => {
      task.converted_total_minutes = this.convertMinutesToHoursMinutes(task.total_minutes);
      task.user = user.user_name;
      return task;
    });
  })
  .flat();

// Calculate the total task count and total minutes (in minutes)
const totalTaskCount = userAnalysisTable.reduce((total, item) => total + item.count, 0);
const totalMinutes = userAnalysisTable.reduce((total, item) => {
  const [hours, minutes] = item.converted_total_minutes.split(':').map(Number);
  return total + (hours * 60) + minutes;
}, 0);

// Create the summary row
const summaryRow = {
  count: totalTaskCount,
  user: 'Total',
  task_title: '',
  converted_total_minutes: this.convertMinutesToHoursMinutes(totalMinutes),
  task_id: '',
};

userAnalysisTable.push(summaryRow);

const cleanedUserAnalysisTable = userAnalysisTable.map(item => {
  const { converted_total_minutes, ...rest } = item;
  rest.total_minutes = item.converted_total_minutes;
  return rest;
});

      store
        .dispatch("user-report/downloadPDF3", {
          datePeriod:
            dates[0].toDateString() + " to " + dates[1].toDateString(),
          departments: this.departmentOptions
            .filter((e) => {
              return this.selectedDepartments.includes(e.id);
            })
            .map((e) => {
              return e.label;
            })
            .toString(),
          userWeeklyTasksBarChart: document
            .getElementById("userWeeklyTasksBarChart")
            .toDataURL(),
          userAnalysisTable: cleanedUserAnalysisTable,
          type:this.selectedReport
        })
        .then((res) => {
          if (res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "dashboard-report.pdf");
            document.body.appendChild(link);
            link.click();

            this.$swal({
              title: "Succesfull!",
              text: "✔️ Report is created!",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching user report:", error);
        });
    },
  },
};
</script>

<style scoped>
canvas {
  max-width: 100%;
}

.total-tasks-display h2 {
  font-size: 4em;
  color: #42a5f5;
  text-align: center;
}

.flat-pickr-wrapper {
  display: flex;
  align-items: center;
}

.flat-pickr-wrapper .form-control {
  margin-right: 1rem;
}

.flat-pickr-wrapper .d-flex {
  flex-wrap: wrap;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
